import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IProductItem } from '@x/ecommerce-shop/app/core/product/types/product-item';
import { ButtonSizes } from '@x/ecommerce-shop/app/core/utils/directives/button-size.directive';

@Component({
  selector: 'x-product-add-to-bag',
  templateUrl: './product-add-to-bag.component.html',
  styleUrls: ['./product-add-to-bag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-product-add-to-bag' },
})
export class ProductAddToBagComponent {
  @Input() productView: IProductItem;
  @Input() loading: boolean;
  @Input() buttonSize: ButtonSizes = 'medium';
  @Output() quantityChanged = new EventEmitter<number>();
}
